<!-- routes/ComingSoon/Hero.svelte -->
<script>
  import Container from "lib/components/Container.svelte";
  import Button from "lib/components/Button.svelte";
  import { _ } from "svelte-i18n";

  function scrollToEmailForm() {
    const emailSection = document.querySelector(".email-section");
    if (emailSection) {
      emailSection.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }
</script>

<!-- Hero Section -->
<Container variant="dark" class="hero-section">
  <div class="hero-content">
    <div class="hero-text">
      <div class="launch-ribbon-row">
        <div class="launch-ribbon">
          <span class="ribbon-text">{$_("hero.launchRibbon")}</span>
        </div>
      </div>

      <div class="hero-title-container">
        <h1 class="hero-title">
          {@html $_("hero.title", {
            values: {
              goldText: `<span class="gold-text">${$_("hero.goldText")}</span>`,
            },
          })}
        </h1>
      </div>

      <div class="hero-features">
        <div class="feature-item">
          <div class="feature-icon">💰</div>
          <div class="feature-content">
            <div class="feature-title">{$_("hero.features.buyWith")}</div>
            <div class="currency-list">
              <span class="currency-pair">
                <img
                  src="/legal/images/Australia.svg"
                  alt="Australia"
                  class="currency-flag"
                />
                <span class="currency-code">AUD</span>
              </span>
              <span class="currency-pair">
                <img
                  src="/legal/images/USA.svg"
                  alt="USA"
                  class="currency-flag"
                />
                <span class="currency-code">USD</span>
              </span>
              <span class="currency-pair">
                <img
                  src="/legal/images/EU.svg"
                  alt="EU"
                  class="currency-flag"
                />
                <span class="currency-code">EUR</span>
              </span>
              <span class="currency-pair">
                <img
                  src="/legal/images/UK.svg"
                  alt="UK"
                  class="currency-flag"
                />
                <span class="currency-code">GBP</span>
              </span>
              <span class="currency-pair">
                <img
                  src="/legal/images/Singapore.svg"
                  alt="Singapore"
                  class="currency-flag"
                />
                <span class="currency-code">SGD</span>
              </span>
              <span class="currency-pair">
                <img
                  src="/legal/images/Canada.svg"
                  alt="Canada"
                  class="currency-flag"
                />
                <span class="currency-code">CAD</span>
              </span>
              <span class="currency-pair">
                <img
                  src="/legal/images/New_Zealand.svg"
                  alt="New Zealand"
                  class="currency-flag"
                />
                <span class="currency-code">NZD</span>
              </span>
              <span class="currency-pair">
                <img
                  src="/legal/images/Turkey.svg"
                  alt="Turkey"
                  class="currency-flag"
                />
                <span class="currency-code">TRY</span>
              </span>
            </div>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon">🪙</div>
          <div class="feature-content">
            <span>{$_("hero.features.zeroFees")}</span>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon">⚡</div>
          <div class="feature-content">
            <span>{$_("hero.features.instantTransfer")}</span>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon">💱</div>
          <div class="feature-content">
            <span>{$_("hero.features.sellFor")} </span>
            <div class="payment-providers">
              <img
                src="/images/alipay_logo.svg"
                alt="Alipay"
                class="payout-provider-logo"
              />
              <span>Alipay</span>
              <span class="separator">&</span>
              <img
                src="/images/unionpay_logo.svg"
                alt="UnionPay"
                class="payout-provider-logo"
              />
              <span>UnionPay</span>
            </div>
          </div>
        </div>

        <div class="hero-cta">
          <Button
            variant="primary"
            size="large"
            on:click={scrollToEmailForm}
            className="preregister-cta"
          >
            {$_("hero.cta.preregister")}
          </Button>
        </div>
      </div>
    </div>

    <div class="hero-visual">
      <div class="visual-container">
        <div class="transaction-timeline">
          <div class="timeline-step">
            <div class="step-number">1</div>
            <div class="step-visual">
              <img
                src="/legal/images/Australia.svg"
                alt="AUD"
                class="step-icon"
              />
              <span class="step-label">AUD</span>
            </div>
            <div class="timeline-card">
              <div class="transaction-amount">
                {$_("hero.timeline.step1.amount")}
              </div>
              <div class="transaction-description">
                {$_("hero.timeline.step1.description")}
              </div>
            </div>
          </div>

          <div class="timeline-connector">
            <div class="connector-arrow">→</div>
          </div>

          <div class="timeline-step">
            <div class="step-number">2</div>
            <div class="step-visual">
              <div class="step-icon gold-coin">🪙</div>
              <span class="step-label">Gold</span>
            </div>
            <div class="timeline-card">
              <div class="transaction-amount">
                {$_("hero.timeline.step2.amount")}
              </div>
              <div class="transaction-description">
                {$_("hero.timeline.step2.description")}
              </div>
            </div>
          </div>

          <div class="timeline-connector">
            <div class="connector-arrow">→</div>
          </div>

          <div class="timeline-step">
            <div class="step-number">3</div>
            <div class="step-visual">
              <img src="/legal/images/China.svg" alt="CNY" class="step-icon" />
              <span class="step-label">CNY</span>
            </div>
            <div class="timeline-card">
              <div class="transaction-amount">
                {$_("hero.timeline.step3.amount")}
              </div>
              <div class="transaction-description">
                {$_("hero.timeline.step3.description")}
                <span class="transaction-appreciation"
                  >{$_("hero.timeline.step3.appreciation")}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="reference-notes">
          <img
            src="/images/aud_price_chart.jpg"
            alt="XAU to AUD (Gold Price Chart)"
            class="price-chart"
          />
          <div class="reference-note">
            {$_("hero.reference.note1")}
          </div>
          <div class="reference-note">
            {$_("hero.reference.note2")}
          </div>
        </div>
      </div>
    </div>
  </div>
</Container>

<style lang="scss">
  /* Hero Section */
  .hero-section {
    min-height: 100vh;
    display: flex;
    align-items: center;
    padding-top: 2rem;
  }

  .hero-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    align-items: center;
  }

  .launch-ribbon-row {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1.5rem;
  }

  .launch-ribbon {
    background: linear-gradient(135deg, #d2a552 0%, #f6efd3 100%);
    color: #1a0f1c;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 700;
    animation: bounce 2s infinite;
    box-shadow: 0 4px 15px rgba(210, 165, 82, 0.4);
    white-space: nowrap;
    position: static;
    transform: none;
  }

  .hero-title-container {
    margin-bottom: 2rem;
  }

  .hero-title {
    font-size: 3.5rem;
    font-weight: 800;
    color: var(--text-color1);
    line-height: 1.1;
  }

  :global(.gold-text) {
    background: linear-gradient(135deg, #d2a552 0%, #f6efd3 50%, #dbbb6b 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .ribbon-text {
    display: block;
    white-space: nowrap;
  }

  .hero-features {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .feature-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    color: var(--text-color2);
    font-size: 1rem;
  }

  .feature-icon {
    font-size: 1.2rem;
    width: 32px;
    flex-shrink: 0;
  }

  .feature-content {
    flex: 1;
    line-height: 1.5;
  }

  .feature-title {
    font-weight: 600;
    margin-bottom: 0.25rem;
    display: block;
    color: var(--text-color2);
  }

  .currency-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center;
    line-height: 1.4;
  }

  .currency-pair {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  .currency-flag {
    width: 16px;
    height: 12px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .currency-code {
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--text-color2);
  }

  .payment-providers {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    margin-top: 0.5rem;
    flex-wrap: wrap;
  }

  .payout-provider-logo {
    font-size: 1.5rem;
    width: 40px;
    height: 40px;
    border-radius: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .separator {
    color: var(--text-color2);
    font-weight: 500;
    margin: 0 0.2rem;
  }

  .hero-cta {
    margin-top: 2rem;
    width: 100%;
  }

  :global(.preregister-cta) {
    background: linear-gradient(135deg, #d2a552 0%, #f6efd3 50%, #dbbb6b 100%);
    color: #1a0f1c;
    border: none;
    padding: 1rem 2rem;
    font-weight: 700;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(210, 165, 82, 0.4);
    transition: all 0.3s ease;
    text-transform: none;
    font-size: 1.1rem;
    min-width: 320px;
    white-space: nowrap;
  }

  :global(.preregister-cta:hover) {
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(210, 165, 82, 0.5);
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    :global(.preregister-cta) {
      min-width: 380px; /* Match tablet feature list width */
    }
  }

  /* Hero Visual */
  .visual-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0rem;
  }

  .transaction-timeline {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    margin-bottom: 1.5rem;
    justify-content: center;
  }

  .timeline-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.6rem;
  }

  .step-number {
    width: 30px;
    height: 30px;
    background: linear-gradient(135deg, #d2a552 0%, #f6efd3 100%);
    color: #1a0f1c;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.8rem;
    box-shadow: 0 4px 15px rgba(210, 165, 82, 0.3);
  }

  .step-visual {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.4rem;
  }

  .price-chart {
    width: 100%;
    max-width: 512px;
    padding-bottom: 32px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .step-icon {
    width: 24px;
    height: 18px;
    object-fit: cover;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gold-coin {
    font-size: 1.2rem;
    width: 24px;
    height: 18px;
    background: transparent;
    border-radius: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .step-label {
    color: var(--text-color1);
    font-weight: 600;
    font-size: 0.75rem;
  }

  .timeline-card {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    padding: 0.8rem;
    text-align: center;
    backdrop-filter: blur(10px);
    width: 140px;
    min-height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .timeline-connector {
    display: flex;
    align-items: center;
    margin: 0 0.4rem;
  }

  .connector-arrow {
    color: #d2a552;
    font-size: 1.1rem;
    font-weight: 600;
  }

  .transaction-amount {
    font-size: 1rem;
    font-weight: 700;
    color: var(--text-color1);
    line-height: 1;
    margin-bottom: 0.3rem;
  }

  .transaction-description {
    font-size: 0.75rem;
    color: var(--text-color2);
    line-height: 1.3;
  }

  .transaction-appreciation {
    color: #28a745;
    font-weight: bold;
    font-size: 14px;
  }

  .reference-notes {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    margin-top: 0.8rem;
    padding-top: 0.8rem;
  }

  .reference-note {
    font-size: 0.6rem;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.2;
    text-align: center;
  }

  /* Animations */
  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }

  /* Tablet Responsive Design */
  @media (max-width: 1024px) and (min-width: 769px) {
    .hero-content {
      grid-template-columns: 1fr;
      gap: 3rem;
      max-width: 800px;
      margin: 0 auto;
      text-align: center;
    }

    .hero-text {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .hero-title {
      font-size: 3rem;
      text-align: center;
    }

    .launch-ribbon-row {
      justify-content: center;
    }

    .hero-title-container {
      text-align: center;
      width: 100%;
    }

    .hero-features {
      max-width: 380px;
      margin: 0 auto;
      align-items: flex-start;
    }

    .feature-item {
      justify-content: flex-start;
      text-align: left;
    }

    .feature-content {
      text-align: left;
    }

    .feature-title {
      text-align: left;
    }

    .currency-list {
      justify-content: center;
      max-width: 600px;
      margin: 0 auto;
    }

    .payment-providers {
      justify-content: center;
    }

    .hero-cta {
      display: flex;
      justify-content: center;
    }

    .visual-container {
      max-width: 700px;
      margin: 0 auto;
    }

    .transaction-timeline {
      gap: 1.5rem;
      justify-content: center;
      margin-bottom: 2rem;
    }

    .timeline-card {
      width: 160px;
      min-height: 80px;
      padding: 1rem;
    }

    .price-chart {
      max-width: 600px;
    }

    .reference-notes {
      max-width: 600px;
      margin: 1rem auto 0;
    }
  }

  /* Mobile Responsive Design */
  @media (max-width: 768px) {
    .hero-content {
      grid-template-columns: 1fr;
      gap: 2rem;
      text-align: center;
    }

    .hero-text {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .hero-title {
      font-size: 2.5rem;
    }

    .launch-ribbon {
      position: static;
      transform: none;
      display: inline-block;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    .hero-title-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      width: 100%;
    }

    .hero-features {
      max-width: 320px;
      margin: 0 auto;
      align-items: flex-start;
    }

    .feature-item {
      justify-content: flex-start;
      text-align: left;
    }

    .feature-content {
      text-align: left;
    }

    .feature-title {
      text-align: left;
    }

    .currency-list {
      justify-content: flex-start;
    }

    .payment-providers {
      justify-content: flex-start;
    }

    .hero-cta {
      display: flex;
      justify-content: center;
    }
    .transaction-timeline {
      flex-direction: column;
      gap: 0.5rem;
    }

    .timeline-connector {
      transform: rotate(90deg);
      margin: 0.5rem 0;
    }

    .connector-arrow {
      font-size: 1.1rem;
    }

    .timeline-card {
      padding: 0.8rem;
      min-width: 140px;
      max-width: 280px;
      width: auto;
    }

    .step-number {
      width: 36px;
      height: 36px;
      font-size: 0.9rem;
    }

    .transaction-amount {
      font-size: 1.1rem;
    }

    .transaction-description {
      font-size: 0.8rem;
    }

    .reference-note {
      font-size: 0.65rem;
    }
  }

  @media (max-width: 480px) {
    .hero-title {
      font-size: 2rem;
    }

    .hero-features {
      gap: 1.2rem;
    }

    .feature-icon {
      font-size: 1.1rem;
      width: 28px;
    }

    .currency-flag {
      width: 14px;
      height: 10px;
    }

    .currency-code {
      font-size: 0.85rem;
    }
  }

  @media (max-width: 360px) {
    .hero-title {
      font-size: 1.75rem;
    }

    .hero-features {
      gap: 1rem;
    }

    .feature-item {
      font-size: 0.9rem;
    }

    .feature-icon {
      font-size: 1rem;
      width: 24px;
    }

    .currency-flag {
      width: 12px;
      height: 9px;
    }

    .currency-code {
      font-size: 0.8rem;
    }

    .separator {
      margin: 0 0.1rem;
    }

    .launch-ribbon {
      font-size: 0.7rem;
      padding: 0.4rem 0.8rem;
    }
  }

  @media (max-width: 400px) {
    /* Prevent overflow by ensuring all content respects container width */
    .hero-content {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
    }

    .launch-ribbon-row {
      margin-bottom: 0rem;
    }

    .hero-text,
    .hero-visual {
      width: 100%;
      max-width: 100%;
      overflow: hidden;
    }

    /* Compact hero title */
    .hero-title {
      font-size: 2rem;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    /* Tighter spacing */
    .hero-features {
      gap: 0.6rem;
      width: 100%;
    }

    .feature-item {
      font-size: 0.8rem;
      width: 100%;
      max-width: 100%;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    /* Compact currency list */
    .currency-list {
      gap: 0.4rem;
      flex-wrap: wrap;
      width: 100%;
    }

    .currency-pair {
      gap: 0.2rem;
      flex-shrink: 0;
    }

    /* Ensure visual container doesn't overflow */
    .visual-container {
      width: 100%;
      max-width: 100%;
      overflow: hidden;
    }

    /* Compact timeline */
    .timeline-card {
      padding: 0.5rem;
      min-width: 100px;
      max-width: 200px;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .transaction-timeline {
      width: 100%;
      max-width: 100%;
      overflow: hidden;
      gap: 0.2rem;
    }

    .transaction-amount {
      font-size: 0.9rem;
    }

    .transaction-description {
      font-size: 0.7rem;
      line-height: 1.2;
    }

    /* Prevent button overflow */
    :global(.preregister-cta) {
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }
  }
</style>
